// frontend/src/pages/storeActivity/GlanceStrip.jsx
//
// The store as a whole, in one row: how much data it holds, what it earns,
// and whether it can use the app today.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormatters } from '../../hooks/useFormatters';
import { stateLabel } from './billingStateRow';
import { Stat } from './primitives';
import { EMPTY } from './text';

// "Drafts 3 · Open 2 · Fully received 5": the rows that are non-zero, in the
// backend's order. Zero rows are noise on a tile, and a tile with nothing to
// break down (or nothing at all) carries no note.
function breakdownNote(breakdown, t, formatNumber) {
  const rows = breakdown.filter((b) => b.count > 0);
  if (rows.length === 0) return null;
  return rows
    .map((b) => `${t(`storeActivity.footprintBreakdown.${b.key}`)} ${formatNumber(b.count, 0)}`)
    .join(' · ');
}

export default function GlanceStrip({ footprint, billing }) {
  const { t } = useTranslation();
  const { formatNumber, formatCurrency } = useFormatters();
  const { revenue } = billing;

  return (
    <div className="sa-glance">
      {footprint.map((f) => (
        <Stat
          key={f.key}
          value={formatNumber(f.count, 0)}
          label={t(`storeActivity.footprint.${f.key}`)}
          note={breakdownNote(f.breakdown, t, formatNumber)}
        />
      ))}
      {/* USD, because it is the figure the tier was priced from; the
          shop-currency figure and the rate behind it are in the details. */}
      <Stat
        value={revenue.annual_usd === null ? EMPTY : formatCurrency(revenue.annual_usd, 'USD')}
        label={t('storeActivity.glance.revenue')}
      />
      {/* Access is its own tile rather than something to infer from the
          state, because the mapping is not guessable from the name (a
          grace period grants, a running trial denies). The state sits under
          it so a denial names its cause. */}
      <Stat
        value={t(billing.access_granted
          ? 'storeActivity.billing.access.granted'
          : 'storeActivity.billing.access.denied')}
        label={t('storeActivity.glance.access')}
        note={stateLabel(billing.status, t)}
        warn={!billing.access_granted}
      />
    </div>
  );
}
